import {DOWNLOAD_FILE, UPLOAD_FILE_PLANHANDLE} from '../actions/actionTypes'
import { UploadFilePlanHandleSuccessAction } from '../actions'

import { put, takeLatest} from 'redux-saga/effects'
import { Api } from './api'


function* DownloadFile(action){
    try{
        yield Api.Downloadfile(action.value);
        
    }catch(error){
        console.log("error",error)
    }
}
export function* watchDownloadFile(){
    yield takeLatest(DOWNLOAD_FILE, DownloadFile)
}

function* UploadFile(action){
    try{
        const DataFile = yield Api.UploadFileFromApi(action.file);
        yield put(UploadFilePlanHandleSuccessAction(DataFile, action.index))
    }catch(error){
        console.log("error",error)
    }
}
export function* watchUploadFile(){
    yield takeLatest(UPLOAD_FILE_PLANHANDLE, UploadFile)
}